import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import auth from "../services/auth";
import store from "../store/index";

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  linkActiveClass: "active"
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!auth.isLoggedIn()) {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
      return;
    }
  }

  if (to.matched.some(record => record.meta.roles)) {
    if (
      store.getters["user/user"] &&
      store.getters["user/user"].role &&
      !to.meta.roles.includes(store.getters["user/user"].role.id)
    ) {
      next({
        path: "/404",
        query: { redirect: to.fullPath }
      });
      return;
    }
  }

  next();
});

export default router;
